module.exports = __webpack_public_path__ + "static/media/ieee_logo.c248d2c1.png";